import React from "react";
import { Tabs } from "../../../components/ui";
import FilterSection from "../../../components/ui/FilterSection";

export const InventoryControlPanel = ({
  activeTab,
  setActiveTab,
  search,
  setSearch,
  filters,
  setFilters,
  onAdd,
  tabs = [],
  onExport,
  isExporting
}) => {
  const activeTabLabel = tabs.find(t => t.id === activeTab)?.label.slice(0, -1) || activeTab;

  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <h1 className="text-2xl font-bold text-brand-dark">Inventory Settings</h1>
      </div>

      <div className="p-1">
        <Tabs 
          tabs={tabs} 
          activeTab={activeTab} 
          onChange={(id) => { setActiveTab(id); setSearch(""); }}
          variant="sub"
        />
      </div>

      <FilterSection
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={setFilters}
        onAddClick={activeTab !== 'versions' ? onAdd : undefined}
        addLabel={`Add ${activeTabLabel}`}
        addVariant="primary"
        onExport={onExport}
        isExporting={isExporting}
      />
    </div>
  );
};


